import React from "react";

function Underconstruction() {
  return (
    <div className="custom-content">
      <div style={{textAlign: "center", padding: 40}}>
        <h5>Under construction</h5>
      </div>
    </div>
  );
}

export default Underconstruction;
